export default __webpack_public_path__ + "static/media/vue.89425b46.svg";